// Mirror backend normalizeForMatch (routes/companies.js) for client-side duplicate scan
export function normalizeCompanyName(name) {
  return (name || '')
    .toLowerCase()
    .replace(/[.\-_,;'"()&]/g, ' ')
    .replace(/\b(pvt|ltd|limited|llp|llc|inc|corp|corporation|group|properties|developers|developer|realty|reality|homes|builders|builder|projects|project|infra|infrastructure|estates|estate|constructions|construction|ventures|venture|housing|holdings|holding|assets|spaces|space|lifestyle|india|urban|real estate)\b/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function findDuplicateCompaniesFromData(companies, spocs, city) {
  const list = (companies || []).filter(co => {
    if (!city) return true;
    return (co.city || '').toLowerCase() === city.toLowerCase();
  });

  const spocCountByCompany = {};
  for (const sp of spocs || []) {
    const id = String(sp.companyId?._id || sp.companyId || '');
    if (!id) continue;
    spocCountByCompany[id] = (spocCountByCompany[id] || 0) + 1;
  }

  const groups = {};
  for (const co of list) {
    const norm = normalizeCompanyName(co.name);
    if (!norm) continue;
    const key = norm + '|' + (co.city || '');
    (groups[key] = groups[key] || []).push({
      id: String(co._id),
      name: co.name,
      city: co.city || '',
      salesperson: co.salesperson || '',
      source: co.source || '',
      createdAt: co.createdAt,
      spocCount: spocCountByCompany[String(co._id)] || 0,
    });
  }

  const duplicateGroups = Object.values(groups)
    .filter(g => g.length > 1)
    .map(g => g.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0)))
    .sort((a, b) => b.length - a.length);

  const totalDuplicates = duplicateGroups.reduce((sum, g) => sum + (g.length - 1), 0);
  return { groups: duplicateGroups, groupCount: duplicateGroups.length, totalDuplicates };
}

export function defaultDuplicateGroupSelection(group) {
  const items = Array.isArray(group) ? group : [];
  if (!items.length) return { keepId: '', keepName: '' };
  const best = [...items].sort((a, b) =>
    (b.spocCount || 0) - (a.spocCount || 0)
    || new Date(a.createdAt || 0) - new Date(b.createdAt || 0)
  )[0];
  return { keepId: best.id, keepName: best.name || '' };
}

export function buildDuplicateModalState(result) {
  const groups = Array.isArray(result?.groups) ? result.groups : [];
  return {
    ...result,
    groups,
    selections: groups.map(defaultDuplicateGroupSelection),
  };
}
